import { c as _c } from "react/compiler-runtime";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useTeamUtils } from "@hooks/use-team-utils";
import { useToast } from "@flat-ui";
import { TeamTabs } from "@router/route-params";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { useCompanyId } from "@context-providers/company-id-provider";
import { TeamEvents, WorkspaceMemberEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * @returns utility functions to open and navigate to member related pages
 */
export function useMembersUtils() {
  const $ = _c(13);
  const companyId = useCompanyId();
  const {
    navigateToMemberProfile,
    navigateToTeamMembers
  } = useAppNavigation();
  const {
    openTeamDetails
  } = useTeamUtils();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  let t0;
  if ($[0] !== companyId || $[1] !== navigateToTeamMembers || $[2] !== trackEvent) {
    t0 = function openViewTeamMembers(t1) {
      const {
        teamId,
        numberOfMembers
      } = t1;
      trackEvent({
        name: TeamEvents.openTeam,
        props: {
          teamId,
          tab: TeamTabs.members,
          numberOfMembers: numberOfMembers ?? ""
        }
      });
      navigateToTeamMembers({
        companyId,
        teamId
      });
    };
    $[0] = companyId;
    $[1] = navigateToTeamMembers;
    $[2] = trackEvent;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const openViewTeamMembers = t0;
  let t1;
  if ($[4] !== companyId || $[5] !== navigateToMemberProfile || $[6] !== openTeamDetails || $[7] !== openToast || $[8] !== trackEvent) {
    t1 = function openProfilePage(t2) {
      const {
        source,
        member
      } = t2;
      trackEvent({
        name: WorkspaceMemberEvents.openMemberProfilePage,
        props: {
          source
        }
      });
      if (!member) {
        openToast({
          title: "User profile page cannot be opened",
          variant: "error",
          message: "User ID not available. Please reload the page to try again."
        });
        return;
      }
      if (FaroCoreApiUtils.Member.isTeam(member)) {
        openTeamDetails({
          teamId: member.identity
        });
        return;
      }
      navigateToMemberProfile({
        companyId,
        memberId: encodeURIComponent(member.identity)
      });
    };
    $[4] = companyId;
    $[5] = navigateToMemberProfile;
    $[6] = openTeamDetails;
    $[7] = openToast;
    $[8] = trackEvent;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const openProfilePage = t1;
  let t2;
  if ($[10] !== openProfilePage || $[11] !== openViewTeamMembers) {
    t2 = {
      openProfilePage,
      openViewTeamMembers
    };
    $[10] = openProfilePage;
    $[11] = openViewTeamMembers;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}